import React from 'react';

import NextImage from 'next/image';
import { twMerge } from 'tailwind-merge';

import { AppRatingSection } from '../AppRatingSection/AppRatingSection';
import { AppStoreButtons } from '../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Container } from '../Container/Container';
import { Heading } from '../Heading/Heading';
import { QRCode } from '../QRCode/QRCode';
import { Text } from '../Text/Text';

import mobilePhonePreview from './assets/mobilePhonePreview.png';

interface IProps {
  hasAppRating?: boolean;
  headlineText?: string;
  sublineText?: string;
  className?: string;
}

const DEFAULT_HEADLINE_TEXT = 'Download Fishbrain and fish smarter';
const DEFAULT_SUBLINE_TEXT =
  'Unlimited access to the best fishing spot finder in the game. Get all the fishing intel you need to start catching more, and bigger, fish.';

export const AppDownloadSection = ({
  hasAppRating,
  headlineText = DEFAULT_HEADLINE_TEXT,
  sublineText = DEFAULT_SUBLINE_TEXT,
  className,
}: IProps) => {
  return (
    <div className={twMerge(`py-md`, className)} data-testid="AppDownloadSection">
      <Container
        variant="thin"
        className="flex flex-col items-center justify-between px-4 sm:flex-row sm:justify-center"
      >
        <div className="sm:w-col-6 w-col-3 mx-8 flex w-full justify-center sm:-ml-4">
          <NextImage
            className="drop-shadow-phoneMobile sm:drop-shadow-phoneDesktop w-full"
            src={mobilePhonePreview}
            placeholder="blur"
            alt="App Section"
            width={629}
            height={986}
            sizes="(min-width: 1680px) 629px,(min-width: 990px) 50vw, (min-width: 600px) 58vw, 100vw "
          />
        </div>

        <div className="sm:w-col-6 md:w-col-6 flex w-full flex-col items-center justify-center">
          <div className="my-3 flex w-full flex-col gap-2 py-2 md:px-8">
            <Heading as="div" variant="sm" className="hidden text-center sm:block">
              {headlineText}
            </Heading>
            <Heading as="div" variant="lg" className="text-center sm:hidden">
              {headlineText}
            </Heading>
            <Text as="div" className="text-center sm:block">
              {sublineText}
            </Text>
          </div>
          <div className="w-full">
            <div className="flex flex-col items-center justify-center gap-4">
              <div className="flex flex-row justify-center gap-4 sm:flex-wrap">
                <QRCode
                  className="hidden sm:flex sm:justify-center"
                  source="AppDownloadSection"
                  showOnMobileDevice
                />
                <AppStoreButtons className="" orientation="vertical" source="AppDownloadSection" />
              </div>

              <Text variant="xs" className="m-0 font-semibold">
                Free trial available
              </Text>

              {hasAppRating && (
                <AppRatingSection className="items-center justify-center gap-6 sm:flex-row sm:justify-start" />
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
